import styled from "styled-components";

import { defaultColorTheme } from "./defaultColorTheme";

export const Divider = styled.hr`
  width: 100%;
  border-top: 1px solid ${defaultColorTheme["neutralL4"]};
  border-left: 0px;
  margin: 10px 0px 30px 0px;
`;
